require('./multiMap.js');



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/src/multiMap/index.js
// module id = 462
// module chunks = 1